// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-pro/css/all.css";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import 'lightgallery/src/sass/lightgallery.scss';

import {
    jarallax,
    jarallaxVideo
} from 'jarallax';
import 'bootstrap';
import 'slick-carousel';

import basicNavigation from './header/header';
import inlineSVG from './utilities/convert-svg-to-html';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';

import Instafeed from 'instafeed.js';

window.Instafeed = Instafeed;

$(function () {

    AOS.init({
        once: true,
    });

    basicNavigation();

    // jarallaxVideo();

    jarallax(document.querySelectorAll('.HomePage .parallax.intro'), {
        // videoSrc: 'https://www.youtube.com/watch?v=QGAMTlI6XxY',
        // videoStartTime: 35,
        // videoEndTime: 120,
        speed: 0.5
    });

    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');


    /*
    $('.carousel.full-height .slick').slick({
        autoplay: true,
        autoplaySpeed: 10000,
        fade: true,
        arrows: false
    });
     */

    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });


    $('.testimonial-row').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false
                }
            }
        ]
    });


    $('.elemental-sponsors .slick').slick({
        slidesToShow: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    arrows: false,
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 2
                }
            }
        ]
    });

    $('.hail-carousel').each(function(index, element){
        //Build carousel options (from the Hail carousel DataObject)
        const slickOptions = {
            lazyLoad: 'ondemand',
            dots: ($(element).data('showdots') === "Yes"),
            slidesToShow: $(element).data('lg-toshow'),
            slidesToScroll: $(element).data('lg-toscroll'),
            responsive: [
                {
                    breakpoint: $(element).data('md-break'),
                    settings: {
                        slidesToShow: $(element).data('md-toshow'),
                        slidesToScroll: $(element).data('md-toscroll')
                    }
                },
                {
                    breakpoint: $(element).data('sm-break'),
                    settings: {
                        slidesToShow: $(element).data('sm-toshow'),
                        slidesToScroll: $(element).data('sm-toscroll'),
                        arrows: false
                    }
                }
            ]
        };

        $(element).slick(slickOptions);
    });

});
